import { HTTPS_URL_REGEX, URL_REGEX } from "./urlValidation.regex";

export const checkIsUrlInvalid = (value: string, forceProtocol = false): boolean => forceProtocol ? !HTTPS_URL_REGEX.test(value) : !URL_REGEX.test(value);